import SpeciesTraitFeatureSnippet from "./SpeciesTraitFeatureSnippet";

export default SpeciesTraitFeatureSnippet;
export { SpeciesTraitFeatureSnippet };
